module.exports = __webpack_public_path__ + "3e95cfd049ccf1a80907a1e3387a18ee.svg";


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/1x1/do.svg
// module id = ./node_modules/flag-icon-css/flags/1x1/do.svg
// module chunks = 0